/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SortDirection } from '../../models/sort-direction';
import { SubscriptionContactSearch } from '../../models/subscription-contact-search';
import { SubscriptionContactsPagedList } from '../../models/subscription-contacts-paged-list';

export interface SearchSubscriptionContacts$Json$Params {

/**
 * The object ID. Must be a valid ID.
 */
  uid: string;

/**
 * The list items offset
 */
  offset?: number;

/**
 * The list items limit
 */
  limit?: number;

/**
 * Indicates the field to use for sorting the data:
 *   * EMAIL : the mail
 *   * FIRST_NAME
 *   * LAST_NAME
 */
  sortFieldName?: 'EMAIL' | 'FIRST_NAME' | 'LAST_NAME';

/**
 * Sort direction : ASC, DESC
 */
  sortDirection?: SortDirection & any;

/**
 * The search text to filter API
 */
  search?: string;
  
    /**
     * Body for search contacts
     */
    body?: SubscriptionContactSearch
}

export function searchSubscriptionContacts$Json(http: HttpClient, rootUrl: string, params: SearchSubscriptionContacts$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<SubscriptionContactsPagedList>> {
  const rb = new RequestBuilder(rootUrl, searchSubscriptionContacts$Json.PATH, 'post');
  if (params) {
    rb.path('uid', params.uid, {});
    rb.query('offset', params.offset, {});
    rb.query('limit', params.limit, {});
    rb.query('sortFieldName', params.sortFieldName, {});
    rb.query('sortDirection', params.sortDirection, {});
    rb.query('search', params.search, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<SubscriptionContactsPagedList>;
    })
  );
}

searchSubscriptionContacts$Json.PATH = '/custom/subscriptions/{uid}/contacts/search';
